import { Create, SimpleForm, NumberInput, TextInput } from 'react-admin';

export const Tbl_pianiCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <NumberInput source="gruppoId" />
      <TextInput source="nome" />
      <TextInput source="DescrizioneCompleta" multiline />
      <NumberInput source="maxNumeroSquadre" />
      <NumberInput source="maxInfografiche" />
      <NumberInput source="maxPostGg" />
      <NumberInput source="maxPostWeek" />
      <TextInput source="imgQuality" />
      <NumberInput source="Prezzo" step={0.01} />
      <TextInput source="note" multiline />
      <NumberInput source="flVisibile" />
      <NumberInput source="flAttivo" />
      <NumberInput source="flAnnullato" />
      <NumberInput source="ordinamento" />
    </SimpleForm>
  </Create>
);
